import { Control, FieldError, useController } from "react-hook-form";
import { useFormData } from "../../context/FormDataContext";
import { useEffect } from "react";
import { useFilterData } from "../../context/TableDataContext";
import { useAxios } from "../../utils/useAxios";

interface MySelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  control: Control<any>;
  error?: FieldError;
  validationRules?: object;
  selected?: any;
  type?: any;
  options: { value: string; label: string }[];
  depend_key?: any;
  depend_key_name?: any;
}

export function MySelect({
  name,
  error,
  selected,
  control,
  options,
  depend_key,
  depend_key_name,
  ...rest
}: MySelectProps) {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
    defaultValue: selected ?? "",
  });

  const { setFormValue } = useFormData();
  const { formData } = useFormData();

  useEffect(() => {
    if (depend_key) {
      setFormValue(name, Number(value));
    }
  }, [value]);

  useEffect(() => {
    if (depend_key_name) {
    }
  }, [formData]);

  ///filter case
  const { setFilterData } = useFilterData();

  const {
    res: searchRes,
    mutate: searchMutate,
    isPending: searchIsPending,
  } = useAxios({ url: "/api/auth/filterLoad" });

  const getFilterData = (e: any) => {
    searchMutate({
      searchKey: name,
      searchValue: Number(e) || e,
    });
  };

  useEffect(() => {
    if (searchRes) {
      setFilterData(searchRes?.data?.data);
    }
  }, [searchRes]);

  return (
    <div>
      <select
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          getFilterData(e.target.value);
        }}
        className="h-7 w-full border px-2 py-1 text-xs shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
        {...rest}
      >
        <option value="">Select an option</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </div>
  );
}
